import type {
  ProcessingFailure,
} from '../processing/errors';
import type {
  ProcessingRequest,
  ProcessingResult,
} from '../processing/contracts';
import type { ProcessingProgressEvent } from '../processing/progress';

export type ProcessingWorkerRequestMessage =
  | {
      readonly type: 'processing.run';
      readonly request: ProcessingRequest;
    }
  | {
      readonly type: 'processing.cancel';
      readonly jobId: string;
    };

export type ProcessingWorkerResponseMessage =
  | {
      readonly type: 'processing.progress';
      readonly event: ProcessingProgressEvent;
    }
  | {
      readonly type: 'processing.result';
      readonly jobId: string;
      readonly result: ProcessingResult;
    }
  | {
      readonly type: 'processing.error';
      readonly jobId: string;
      readonly failure: ProcessingFailure;
    }
  | {
      readonly type: 'processing.cancelled';
      readonly jobId: string;
    };

function isRecord(value: unknown): value is Readonly<Record<string, unknown>> {
  return typeof value === 'object' && value !== null;
}

export function isProcessingWorkerResponseMessage(
  value: unknown,
): value is ProcessingWorkerResponseMessage {
  if (!isRecord(value) || typeof value.type !== 'string') return false;
  if (value.type === 'processing.progress') {
    return isRecord(value.event) && typeof value.event.jobId === 'string';
  }
  if (
    value.type === 'processing.result' ||
    value.type === 'processing.error' ||
    value.type === 'processing.cancelled'
  ) {
    return typeof value.jobId === 'string';
  }
  return false;
}

export function isProcessingWorkerRequestMessage(
  value: unknown,
): value is ProcessingWorkerRequestMessage {
  if (!isRecord(value) || typeof value.type !== 'string') return false;
  if (value.type === 'processing.cancel') return typeof value.jobId === 'string';
  return value.type === 'processing.run' && isRecord(value.request);
}

